module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp2_7.584c5a36.png";